import { styled } from '@mui/material';
import { FLASH_SALE_BANNER_HEIGHT } from '@src/styles/config';
import { COLOR } from '@src/styles/color';

export const StyledSwiperHeaderBanner = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: ${FLASH_SALE_BANNER_HEIGHT}px;
  z-index: ${(props) => (props.isAgreeToTerm ? 1299 : 1200)};
  display: flex;
  overflow: hidden;

  > div {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 100%;
    transition: left 0.5s ease-in-out, opacity 0.5s ease-in-out;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.1);

    &.active {
      left: 0;
      opacity: 1;
      z-index: 1;
    }

    &.prev {
      left: -100%;
      opacity: 0;
      z-index: 0;
    }

    &.next {
      left: 100%;
      opacity: 0;
      z-index: 0;
    }
  }

  .swiper-dots {
    position: absolute;
    bottom: 4px;
    left: 50%;
    z-index: 2;
    display: flex;
    gap: 4px;
    margin: 0;
    padding: 0;
    list-style: none;
    transform: translateX(-50%);
    pointer-events: none;
  }

  .dot {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background-color: ${COLOR.white};
    box-shadow: 0 0 2px ${COLOR.black[48]};
    opacity: 0.6;
    transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;

    &.active {
      width: 12px;
      opacity: 1;
    }
  }
`;
